import { isFlagEnabled as isFlagEnabledAF } from '@atlassian/teams';
import { getEnv } from '@atlassian/teams-common/context-config';
export let FeatureFlag = /*#__PURE__*/function (FeatureFlag) {
  FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
  FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
  FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
  FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
  FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
  return FeatureFlag;
}({});

// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const DEFAULT_FEATURE_FLAGS = {
  [FeatureFlag.ENABLE_PROJECT_CONNECT_USER_TAGS]: false,
  [FeatureFlag.ENABLE_MOCK_OPEN_SITES_FAIL]: false,
  [FeatureFlag.DISABLE_ATLAS_CROSSWFLOW_ADS]: false,
  [FeatureFlag.EVENT_ON_CALL_EFF]: false,
  [FeatureFlag.EVENT_ON_CALL_CONSOLIDATION_STATE]: false
};

// Overrides only for local/CI environments
const LOCAL_OVERRIDE_FEATURE_FLAGS = {
  // Features rolled out to 100%

  // Atlassian-only features
  [FeatureFlag.ENABLE_PROJECT_CONNECT_USER_TAGS]: true
};
export const initialFeatureFlagList = () => {
  var _process, _process$env;
  return ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development' || getEnv() === 'local' ? {
    ...DEFAULT_FEATURE_FLAGS,
    ...LOCAL_OVERRIDE_FEATURE_FLAGS
  } : {
    ...DEFAULT_FEATURE_FLAGS
  };
};
/**
 * @private
 * @deprecated - use useFeatureFlag or useBooleanFeatureFlag instead.
 * This method return best known flag value, but only compute values from Directory GraphQL,
 * local storage, and default values.
 *
 * Using this in React components should be avoided, as the component won't re-render when
 * feature flag values are loaded.
 */
export function isFlagEnabled(flag) {
  return isFlagEnabledAF(flag);
}